import React, {useEffect, useMemo} from 'react';
import {Button, FormHelperText} from '@material-ui/core';
import {Formik} from 'formik';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import reusableInputStyles from '../../../components/InputStyles';
import {useDispatch, useSelector} from 'react-redux';
import {
  fetchServiceClientDropDownData,
  fetchBillingIndicatorsDropdownData,
  fetchBillingMapData,
  resetData,
  fetchAllBillingIndicatorNumbersAndNames,
  fetchCorporateNameDataBI,
  resetCorparateName,
  resetGetServiceClientData,
  resetCorporateNameData,
} from '../../../redux/reducers/BillingIndicator/index';
import {
  fetchCompanyDropDownData,
  fetchCorporateDropDownData,
  fetchSiteDataBasedOnCorporate,
} from '../../../redux/reducers/clientMangement/Organizaation';
import * as Yup from 'yup';

const AddBillingMapping = ({
  edit,
  setEditFilter,
  setValue,
  setTabLables,
  setFieldCompany,
  formVal,
  setIsOpen,
}) => {
  const classes = reusableInputStyles();
  const {getServiceClientData, corporateNameData, status, billingMapData, rowData} = useSelector(
    ({billingIndicator}) => billingIndicator,
  );
  const {companyAPIdata, siteDataOnCorporate} = useSelector(({organization}) => organization);
  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    companyName: Yup.mixed().test('companyName', 'Company Name is required', (value) => {
      if (!value?.companyId) {
        return false;
      } else {
        return true;
      }
    }),
  });
  const filterCompany = (data) => {
    const filtered = data?.filter((item) => {
      if (!filteredCompanies.includes(item?.companyName)) {
        return item;
      }
    });
    return filtered;
  };
  const filteredCompanies = useMemo(() => {
    return formVal?.fields
      ?.filter((data) => {
        return (
          data?.companyName?.companyName &&
          !data?.corporateName?.corporateName &&
          !data?.serviceClientName?.serviceClientName &&
          !data?.siteName
        );
      })
      .map((data) => data.companyName.companyName);
  }, [formVal]);

  useEffect(() => {
    dispatch(fetchBillingIndicatorsDropdownData());
    dispatch(fetchCompanyDropDownData());
    dispatch(fetchCorporateDropDownData());
  }, []);
  useEffect(() => {
    dispatch(fetchAllBillingIndicatorNumbersAndNames());
  }, []);
  useEffect(() => {
    if (billingMapData?.siteId && billingMapData?.corporateId && billingMapData?.companyId) {
      dispatch(
        fetchServiceClientDropDownData(
          billingMapData?.siteId,
          billingMapData?.corporateId,
          billingMapData?.companyId,
        ),
      );
    }
  }, [billingMapData?.siteId, billingMapData?.corporateId, billingMapData?.companyId]);
  useEffect(() => {
    if (status === 200) {
      setEditFilter(false);
      setTimeout(() => {
        dispatch(resetData());
      }, 2000);
    }
  }, [status]);

  useEffect(() => {
    if (rowData?.billingIndicatorId) {
      dispatch(fetchBillingMapData(rowData?.billingIndicatorId));
    }
  }, [rowData?.billingIndicatorId]);

  useEffect(() => {
    if (billingMapData?.corporateId) {
      dispatch(fetchSiteDataBasedOnCorporate(billingMapData?.corporateId));
    }
  }, [billingMapData?.corporateId]);

  const initialValues = {
    companyName: null,
    corporateName: null,
    siteName: null,
    serviceClient: null,
  };

  const handleSubmit = (data) => {
    setFieldCompany('fields', [...formVal?.fields, data]);
    setIsOpen(false);
  };

  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        enableReinitialize
        validationSchema={validationSchema}
      >
        {(props) => {
          const {values, handleSubmit, handleBlur, setFieldValue, resetForm, touched, errors} =
            props;
          return (
            <div className="px-4">
              <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <div className="form-row  new-standard-textfields">
                  <div className="col-sm-8 col-md-6 col-lg-4 col-xl-6 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="companyName"
                      id="companyName"
                      size="small"
                      onBlur={handleBlur}
                      value={values.companyName}
                      options={filterCompany(companyAPIdata) || []}
                      getOptionLabel={(option) => {
                        return option.companyName || '';
                      }}
                      onChange={(e, value) => {
                        setFieldValue('companyName', value);
                        setFieldValue('corporateName', {});
                        setFieldValue('serviceClient', {});
                        if (value && value?.companyId) {
                          dispatch(fetchCorporateNameDataBI(value?.companyId));
                        }
                        else if(!value) {
                          dispatch(resetCorparateName());
                          setFieldValue('siteName', '');
                          dispatch(resetGetServiceClientData());
                        }
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            variant="outlined"
                            margin="dense"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label="Company Name"
                            required
                            placeholder="Select Company Name"
                            touched={touched.companyName}
                            error={Boolean(
                              !values.companyName?.companyId &&
                                touched.companyName &&
                                errors.companyName,
                            )}
                          />
                        </div>
                      )}
                    />
                    <FormHelperText>
                      {!values.companyName?.companyId && touched.companyName && errors.companyName}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-8 col-md-6 col-lg-4 col-xl-6 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="corporateName"
                      id="corporateName"
                      size="small"
                      onBlur={handleBlur}
                      value={values.corporateName}
                      options={corporateNameData || []}
                      getOptionLabel={(option) => {
                        return option.corporateName || '';
                      }}
                      onChange={(e, value) => {
                        if (!value?.corporateId) {
                          dispatch(resetGetServiceClientData());
                        }
                        setFieldValue('corporateName', value);
                        setFieldValue('siteName', '');
                        setFieldValue('serviceClient', '');
                        value?.corporateId &&
                          dispatch(fetchSiteDataBasedOnCorporate(value?.corporateId));
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            variant="outlined"
                            margin="dense"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            label="Corporate Name"
                            placeholder="Select Corporate Name"
                          />
                        </div>
                      )}
                    />
                  </div>
                  <div className="col-sm-8 col-md-6 col-lg-4 col-xl-6 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="siteName"
                      id="siteName"
                      size="small"
                      value={values.siteName}
                      options={
                        values?.corporateName?.corporateName && siteDataOnCorporate?.length > 0 ?
                          siteDataOnCorporate :
                          []
                      }
                      getOptionLabel={(option) => option?.siteName || ''}
                      onChange={(e, value) => {
                        setFieldValue('siteName', value);
                        setFieldValue('serviceClient', '');
                        if (values?.serviceClient?.suffix) {
                          setFieldValue(
                            'clientNumber',
                            value?.clientPrefix + values?.serviceClient?.suffix,
                          );
                        }
                        if (value && values) {
                          dispatch(
                            fetchServiceClientDropDownData(
                              value?.siteId,
                              values?.corporateName?.corporateId,
                              values?.companyName?.companyId,
                            ),
                          );
                        }
                        else if (!value?.siteId) {
                          dispatch(resetGetServiceClientData());
                        }
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            variant="outlined"
                            margin="dense"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            label="Site Name"
                            placeholder="Select Site Name"
                          />
                        </div>
                      )}
                    />
                  </div>
                  <div className={'col-sm-6 col-md-4 col-lg-6 form-group'}>
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="serviceClient"
                      id="serviceClient"
                      value={values.serviceClient}
                      options={getServiceClientData}
                      getOptionLabel={(option) => {
                        return option && option.serviceClientName ? option?.serviceClientName : '';
                      }}
                      onChange={(e, value) => {
                        setFieldValue('serviceClient', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            // className={` ${classes.labelName}`}
                            error={Boolean(touched.serviceClient && errors.serviceClient)}
                            touched={touched.serviceClient}
                            variant="outlined"
                            margin="dense"
                            label="Client Name"
                            placeholder="Select Client Name"
                          />
                          <FormHelperText variant="outlined">
                            {touched.serviceClient && errors.serviceClient}
                          </FormHelperText>
                        </div>
                      )}
                    />
                  </div>

                  <div className="col-xs-4 col-sm-6 col-md-12 col-lg-12 mb-3">
                    <div className="d-flex justify-content-center">
                      <Button
                        variant="outlined"
                        className={`mr-1 reset-btn`}
                        onClick={() => {
                          resetForm(initialValues);
                          dispatch(resetCorparateName());
                          dispatch(resetGetServiceClientData())
                          dispatch(resetCorporateNameData());
                        }}
                      >
                        Reset
                      </Button>
                      <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                        Save
                      </Button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          );
        }}
      </Formik>
    </>
  );
};

export default AddBillingMapping;
